import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function PencilSquare({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M4.5332 20.8888C4.5332 20.8888 9.65178 20.0809 10.9986 18.7341C12.3455 17.3872 21.4192 8.31346 21.4192 8.31346C22.6096 7.12306 22.6096 5.19311 21.4192 4.00413C20.2288 2.81373 18.2989 2.81373 17.1099 4.00413C17.1099 4.00413 8.03614 13.0779 6.68929 14.4248C5.34245 15.7716 4.53463 20.8902 4.53463 20.8902L4.5332 20.8888Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9334 3.11133H1.68896"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.24452 8.08887H1.68896"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
